import { render, staticRenderFns } from "./MsInput.vue?vue&type=template&id=68f31e8b&scoped=true"
import script from "./MsInput.vue?vue&type=script&lang=js"
export * from "./MsInput.vue?vue&type=script&lang=js"
import style0 from "./MsInput.vue?vue&type=style&index=0&id=68f31e8b&prod&lang=scss&scoped=true"
import style1 from "./MsInput.vue?vue&type=style&index=1&id=68f31e8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f31e8b",
  null
  
)

export default component.exports